import { render, staticRenderFns } from "./PositionModalForm.vue?vue&type=template&id=0ba046ee"
import script from "./PositionModalForm.vue?vue&type=script&lang=js"
export * from "./PositionModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports